import React, { useEffect, useRef } from 'react'
import i18n from 'i18next'

import { capitalizeFirstLetter } from '../../utils/helpers'

const VerbatimMatrix = ({ chartData, yearFilters }) => {
    let elRef = useRef(null)
    let yAxisRef = useRef(null)

    const year = yearFilters[0]

    const yearData = chartData.find((d) => d.year === year)

    const noData = () => (
        <div style={{
            width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
        }}
        >
            <img style={{ width: '150px' }} src={`${process.env.CDN_URL}/images/search-icon-v2.svg`} />
            <div style={{
                fontSize: '20px', marginTop: '10px', fontWeight: '700', color: '#8B99A7',
            }}
            >
                No data has been found
            </div>
        </div>
    )

    if (!yearData) return noData

    const { data, options: dataOptions } = yearData

    const total = Object.values(data).reduce((total, rows) => (
        Object.values(rows).reduce((rowTotal, { count }) => (
            rowTotal + count
        ), total)
    ), 0)

    const colours = [
        [[250, 234, 76], [89, 179, 99]],
        [[232, 85, 95], [250, 234, 76]],
    ]

    const heatMap = [
        [
            [
                [3, 0], [3, 1],
                [2, 0], [2, 1],
            ],
            [
                [3, 2], [3, 3],
                [2, 2], [2, 3],
            ],
        ],
        [
            [
                [1, 0], [1, 1],
                [0, 0], [0, 1],
            ],
            [
                [1, 2], [1, 3],
                [0, 2], [0, 3],
            ],
        ],
    ]

    const options = [
        [dataOptions?.[0]?.[0 ?? ''], dataOptions?.[1]?.[0] ?? ''],
        [dataOptions?.[2]?.[0 ?? ''], dataOptions?.[3]?.[0] ?? ''],
    ]
    const buildSegment = (rowIndex, colIndex) => {
        const [r, g, b] = colours[rowIndex][colIndex]
        const segment = options?.[rowIndex]?.[colIndex] ?? ''
        const segmentData = Object.entries(data[segment.toLowerCase()] ?? {})

        const segmentTotal = segmentData.reduce((total, [_, { count }]) => (count + total), 0)
        const segmentPct = segmentTotal / (total || 1) * 100

        return (
            <div
                className="segment"
                style={{
                    background: 'rgba(239, 244, 246, 1)',
                    padding: '16px',
                    borderRadius: '16px',
                }}
            >
                <div
                    style={{
                        backgroundColor: `rgba(${r}, ${g}, ${b}, 1)`,
                        textAlign: 'center',
                        borderRadius: '8px 8px 0px 0px',
                        padding: '12px',
                        fontSize: '14px',
                        fontWeight: '600',
                    }}
                >
                    {capitalizeFirstLetter(segment)}
                    {' '}
                    ({parseInt(Math.round(segmentPct), 10)}%)
                </div>
                <div
                    style={{
                        display: 'flex',
                        gap: '8px',
                        flex: 1,
                        padding: '16px',
                        flexDirection: 'column',
                        borderRadius: '0px 0px 8px 8px',
                        overflowY: 'auto',
                        minHeight: 0,
                        background: '#FFF',
                    }}
                >
                    {segmentData.map(([k]) => <div>{k}</div>)}
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (total === 0) return
        yAxisRef.style.width = `${elRef.getBoundingClientRect().height}px`
    })

    return (
        <div
            className="heatMap"
        >
            <div
                className="heatMapContainer"
                ref={(el) => { elRef = el }}
            >
                {heatMap.map((row, rowIndex) => (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                gap: '24px',
                                flex: 1,
                                minHeight: 0,
                            }}
                        >
                            {row.map((_, colIndex) => (
                                <div
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        minHeight: 0,
                                    }}
                                >
                                    {buildSegment(rowIndex, colIndex)}
                                </div>
                            ))}
                        </div>
                    </>
                ))}
                <div
                    className="yAxis"
                    ref={(el) => yAxisRef = el}
                >
                    {i18n.t('dashboard.HeatMap.yAxisTitle')}
                </div>
                <div
                    className="xAxis"
                >
                    {i18n.t('dashboard.HeatMap.xAxisTitle')}
                </div>
            </div>
        </div>
    )
}

export default VerbatimMatrix
